<template>
  <div class="photo-wrapper" :class="{ desktop: $isDesktop }">
    <div class="photo-count-fullscreen">
      <img
        src="@/assets/images/photo-icon-white.svg"
        width="17"
        height="17"
        alt=""
        class="photograph icon"
      />
      <i class="photo-count">{{ photoCount }}</i>
      <img
        src="@/assets/images/fullscreen.svg"
        width="16"
        height="16"
        alt=""
        class="fullscreen icon"
      />
    </div>
    <img
      :loading="lazy ? 'lazy' : 'eager'"
      :alt="photoCaptionAltFormatter(pitchTypePrimaryPhoto.caption)"
      :src="`/_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=264,h=198${pitchTypePrimaryPhoto.url.masterImage}`"
      :srcset="`
            /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=264,h=198${pitchTypePrimaryPhoto.url.masterImage} 264w,
            /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=70,w=360,h=270${pitchTypePrimaryPhoto.url.masterImage} 360w
            `"
      :sizes="$isDesktop ? '264px' : '160px'"
      :width="$isDesktop ? '264' : '160'"
      :height="$isDesktop ? '198' : '120'"
      class="pt-primary"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { PitchTypePhoto } from '../../../../campsite-details/types'
import { photoCaptionAltFormatter } from '~/utility/photoCaptionAltFormatter'

@Component
class PitchTypeImage extends Vue {
  @Prop({ default: true })
  lazy: boolean

  @Prop({ required: true })
  pitchTypePrimaryPhoto: PitchTypePhoto[]

  @Prop({ required: true })
  photoCount: number

  photoCaptionAltFormatter(caption) {
    return photoCaptionAltFormatter(caption)
  }
}

export default toNative(PitchTypeImage)
</script>

<style scoped>
.pt-primary {
  border-radius: 0.3em;
  display: block;
  flex-shrink: 0;
  height: auto;
  margin: 0;
  width: 9em;
}

.photo-wrapper {
  position: relative;
  place-self: start;
}

.photo-count-fullscreen {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 0.25em;
  padding: 0 0.35em 0.25em;
}

.photo-count {
  font-size: var(--body);
  color: white;
  text-shadow: 0 1px 1px rgb(0 0 0 / 40%);
}

.photos-row .photo-count-fullscreen img {
  border-radius: 0 !important;
  filter: drop-shadow(0 1px 1px rgb(0 0 0 / 40%));
}

.fullscreen.icon {
  margin: 0 0 0 auto;
}

/* desktop & tablet */
.desktop .pt-primary {
  width: 264px;
}

.desktop .photo-wrapper {
  cursor: zoom-in;
}
</style>
